import type { CampaignStatus } from '@iws/theme-schema/campaign'

import type { BadgeTone } from '@/components/ui/badge'

/** Badge tone per derived campaign status. */
export const CAMPAIGN_STATUS_TONES: Record<CampaignStatus, BadgeTone> = {
  draft: 'soft',
  scheduled: 'info',
  live: 'success',
  paused: 'warning',
  ended: 'outline',
}

/** Calendar chip colours per derived campaign status (the badge tones' fills). */
export const CAMPAIGN_STATUS_STYLES: Record<CampaignStatus, string> = {
  draft: 'bg-muted text-text-2',
  scheduled: 'bg-info-lighter text-info-dark',
  live: 'bg-success-lighter text-success-dark',
  paused: 'bg-warning-lighter text-warning-dark',
  ended: 'border border-border text-text-2',
}
